import type { ReactNode } from 'react'
import { useFeedConfig } from '../contexts/feedConfigContext'

/**
 * BettingChrome wraps selection-set card UI (selection lists, top-line odds, etc.)
 * and renders children only when the current surface opts in via
 * `show_betting_chrome = true`. When the surface is content-only (or still
 * loading), BettingChrome returns null so organic posts do not draw betting
 * UI. Callers should keep the generic URL/deep-link CTA (in `CardActions`)
 * OUTSIDE this wrapper so a content-only surface still has a call-to-action.
 */
export function BettingChrome({ children }: { children: ReactNode }) {
  const { surface } = useFeedConfig()
  if (!surface || surface.show_betting_chrome !== true) {
    return null
  }
  return <>{children}</>
}
